import { render, staticRenderFns } from "./NotificationPreview.vue?vue&type=template&id=bc37ec40&scoped=true&"
import script from "./NotificationPreview.vue?vue&type=script&lang=js&"
export * from "./NotificationPreview.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPreview.vue?vue&type=style&index=0&id=bc37ec40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc37ec40",
  null
  
)

export default component.exports